import { render, staticRenderFns } from "./StudentsConditions.vue?vue&type=template&id=4db64cba&scoped=true"
import script from "./StudentsConditions.vue?vue&type=script&lang=ts"
export * from "./StudentsConditions.vue?vue&type=script&lang=ts"
import style0 from "./StudentsConditions.vue?vue&type=style&index=0&id=4db64cba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db64cba",
  null
  
)

export default component.exports